<template lang="pug">
  extends ../tool/CommonEdit.pug
  block detail
    include ./PLCRequestPart.pug

</template>

<script >
  import {Model} from "./imports.js"

  import CommonEdit from "../tool/CommonEdit.js"

  import PLCType from "../../model/plctype/PLCType.js"

  let plcTypeModel = new PLCType()

  export default {
    extends: CommonEdit,
    components: {
    },
    props: {
    },
    data: () => ({
      types: []
    }),
    watch: {
    }, 

    methods: {
      prepareItemToCreate: function() {
        let _self = this

        //console.log(this.item)

        if (this.item.parent_id != null) {
          plcTypeModel.get(
            {id: this.item.parent_id}
            , response => {
              _self.item.parent = response.data
              console.log("parent", _self.item.parent)
            }
            , (e) => {
              console.log(e)
              _self.$emit('error', 'common.not_found', e)
            }
          )
        } 
      },

      loadModel: function() {
        this.model = new Model()
      },

      setup: function(){
        let _self = this

        plcTypeModel.listAll(
          response => {
            _self.types = response.data.results
          }
          , (e) => {
            console.log(e)
            _self.$emit('error', 'common.not_found', e)
          }
        )
      },
    },
  }

</script>